import React from 'react';
import { Form, Input, Select } from 'antd';

const FI = Form.Item;

const FInput = ({ label, ...props }) => (
  <FI label={label}>
    <Input {...props} />
  </FI>
);

const FSelect = ({ label = '', ...props }) => (
  <FI label={label}>
    <Select {...props} />
  </FI>
);

const Option = Select.Option;

export { FInput, FSelect, Option };



// WEBPACK FOOTER //
// ./src/common/form/index.js